import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../constants'
import { QuotaService } from '../services/quota.service'
import type {
	GetQuotaPurchaseHistoryQuery,
	QuotaPurchaseHistoryResponse,
} from '../../types'

export const useQueryGetQuotaPurchaseHistory = (
	query?: GetQuotaPurchaseHistoryQuery,
) => {
	return useQuery<QuotaPurchaseHistoryResponse>({
		queryKey: QUERY_KEYS.QUOTA.HISTORY(query),
		queryFn: () => QuotaService.getQuotaPurchaseHistory(query),
	})
}
